import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';

@jsonObject
export class PublicBannerCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(String)
  public readonly location!: BannerLocationType;

  @jsonMember(MultimediaResponse)
  public readonly file!: MultimediaResponse;

  @jsonMember(MultimediaResponse)
  public readonly smallFile?: Nillable<MultimediaResponse>;
}
